import axios from 'axios';

import { APIResponseParsed } from 'types/response';
import { getRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

type MyUserIdentity = {
  id: number;
};

async function fetchMe(): Promise<APIResponseParsed<MyUserIdentity>> {
  const retryOnError = false;
  const undefinedConfig = undefined;
  try {
    const response = await getRequest<MyUserIdentity>('user/me', undefinedConfig, retryOnError);
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export default {
  fetchMe
};
